import React, { ChangeEvent } from 'react';
import { civiliteDef } from '../../../../../../../types/client/client.def';
import { LabelInput } from 'components/atoms/Inputs/LabelInput';
import { HeaderText } from 'components/atoms/Texts/HeaderText';
import { FeatureContainer } from 'components/molecules/Containers/FeatureContainer';
import { Select } from 'components/atoms/Inputs/Select';
import useStyle from '../../../formCommande.style';
import { ErrorsForm } from 'types/forms/form.def';
import { ClientInput } from 'graphql/generated/graphql';
import emojis from 'theme/emoji';

export interface HorsLyceeFieldsProps {
  handleChange: (e: ChangeEvent<HTMLInputElement>) => void;
  handleChangeSwitch: (value: boolean, name: string) => void;
  client: ClientInput;
  sameClient: boolean;
  errors: ErrorsForm;
}

const HorsLyceeFields = ({
  handleChange,
  handleChangeSwitch,
  client,
  sameClient,
  errors
}: HorsLyceeFieldsProps) => {
  const classes = useStyle();

  return (
    <>
      <HeaderText text="Information de livraison" emoji={emojis['PostBox']} />
      <div style={{ width: '100%' }}>
        <FeatureContainer>
          {!sameClient ? (
            <>
              <div className={classes.selectdiv}>
                <span>Civilité du contact de livraison</span>
                <Select
                  productsOptions={[
                    { id: 'default', name: 'Choisir une valeur' },
                    ...civiliteDef
                  ]}
                  value={client.civilitelivraison || ''}
                  onChange={value =>
                    handleChangeSwitch(value, 'civilitelivraison')
                  }
                />
              </div>
              <LabelInput
                label="Prénom"
                name="prenomlivraison"
                placeHolder=""
                onChange={handleChange}
                value={client.prenomlivraison || ''}
                error={errors && errors.prenomlivraison}
              />
              <LabelInput
                label="Nom"
                name="nomlivraison"
                placeHolder=""
                onChange={handleChange}
                value={client.nomlivraison || ''}
                error={errors && errors.nomlivraison}
              />
              <LabelInput
                label="Téléphone"
                name="mobilelivraison"
                placeHolder=""
                onChange={handleChange}
                value={client.mobilelivraison || ''}
                error={errors && errors.mobilelivraison}
              />
              <LabelInput
                label="Ville"
                name="villelivraison"
                placeHolder=""
                onChange={handleChange}
                value={client.villelivraison || ''}
                error={errors && errors.villelivraison}
              />
              <LabelInput
                label="Adresse de livraison"
                name="adresselivraison"
                placeHolder=""
                onChange={handleChange}
                value={client.adresselivraison || ''}
                error={errors && errors.adresselivraison}
              />
              <LabelInput
                label="Code Postal"
                name="cplivraison"
                placeHolder=""
                onChange={handleChange}
                value={client.cplivraison || ''}
                error={errors && errors.cplivraison}
              />
            </>
          ) : (
            <>
              <p className={classes.horsLyceeBold}>
                Informations de facturation et livraison identiques.
              </p>
              <div>
                <p>{client.civilitelivraison}</p>
                <p>{client.prenomlivraison}</p>
                <p>{client.nomlivraison}</p>
                <p>{client.mobilelivraison}</p>
                <p>{client.villelivraison}</p>
                <p>{client.adresselivraison}</p>
                <p>{client.cplivraison}</p>
              </div>
            </>
          )}
        </FeatureContainer>
      </div>
    </>
  );
};

export default HorsLyceeFields;
